/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// document head manager
import { Helmet } from "react-helmet";
// AWS
import API, { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../graphql/queries.js";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  FormGroup,
  Form,
  Input,
} from "reactstrap";
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.jsx";
import IndexHeader from "components/Headers/IndexHeader.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";
import { I18n } from "aws-amplify";
import { strings } from "i18n/index/index";
I18n.putVocabularies(strings);

import Icon from "../components/Icon/asone.jsx";

var Prismic = require("prismic-javascript");
var apiEndpoint = "https://asone.cdn.prismic.io/api/v2";

class Index extends React.Component {
  state = {
    products: null,
  };

  async componentDidMount() {
    try {
      let organizations = await API.graphql(
        graphqlOperation(queries.listOrganizations)
      );
      console.log(organizations);
    } catch (error) {
      console.error("AWS GQL Error ");
    }

    let products = null;
    await Prismic.getApi(apiEndpoint)
      .then(function (api) {
        return api.query(Prismic.Predicates.at("document.type", "product"));
      })
      .then(
        function (response) {
          products = response.results;
        },
        function (err) {
          console.log("Something went wrong: ", err);
        }
      );
    this.setState({ products });
    console.log(products);
  }

  render() {
    let { products } = this.state;
    return (
      <>
        <Helmet>
          <title>asOne | {I18n.get("slogan")}</title>
        </Helmet>
        <IndexNavbar />
        <div className="main-content">
          <IndexHeader />
          <section id="products" className="py-6 pb-9 bg-default">
            <Container fluid>
              <Row className="justify-content-center text-center">
                <Col md="6">
                  <h2 className="display-3 text-white">
                    {I18n.get("productsTitle")}
                  </h2>
                  <p className="lead text-white">{I18n.get("productsText")}</p>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg pt-lg-0 mt--7">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row>
                    {products &&
                      products
                        .sort(function (a, b) {
                          if (a.uid < b.uid) {
                            return -1;
                          }
                          if (a.uid > b.uid) {
                            return 1;
                          }
                          return 0;
                        })
                        .map((product, index) => {
                          return (
                            <Col lg="4" key={index}>
                              <Card className="card-lift--hover shadow border-0">
                                <Link to={"/products/" + product.uid}>
                                  <CardBody className="py-5">
                                    <div
                                      className="icon icon-shape text-white rounded-circle mb-4"
                                      style={{
                                        background: `linear-gradient(87deg, ${product.data.color_secondary} 0, ${product.data.color_primary} 100%)`,
                                      }}
                                    >
                                      <i className={product.data.nucleo_icon} />
                                    </div>
                                    <h4
                                      className="h3 text-uppercase"
                                      style={{
                                        color: product.data.color_secondary,
                                      }}
                                    >
                                      {product.data.name[0].text}
                                    </h4>
                                    <p className="description mt-3">
                                      {product.data.soustext[0].text}
                                    </p>
                                    <div>
                                      {product.data.concepts.map((concept) => {
                                        return (
                                          <Badge
                                            style={{
                                              backgroundColor:
                                                product.data.color_secondary,
                                              color: "#fff",
                                            }}
                                            pill
                                          >
                                            {concept.concept}
                                          </Badge>
                                        );
                                      })}
                                    </div>
                                  </CardBody>
                                </Link>
                              </Card>
                            </Col>
                          );
                        })}
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-6">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={require("../assets/img/theme/landing-1.png")}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1>{I18n.get("Easy to use")}</h1>
                    <p>
                      Our platform is easy to use via inuitive and intelligent
                      design, allowing your team to get their work done faster.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-settings-gear-65" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">
                              Carefully crafted components
                            </h4>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-html5" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">Amazing page examples</h4>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-satisfied" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">
                              Super friendly support team
                            </h4>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-6">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={require("../assets/img/theme/landing-2.png")}
                  />
                </Col>
                <Col md="6">
                  <div className="pr-md-5">
                    <h1>{I18n.get("Powerful")}</h1>
                    <p>
                      asOne is powerful by design. We created the platform with
                      five basic concepts: 1. the Organization, 2. Users, 3.
                      Clients, 4. Projects, and 5. Locations. Everything is
                      built from there, giving the power to fully operate.
                    </p>
                    <Link
                      className="font-weight-bold text-warning mt-5"
                      to="/admin/profile"
                    >
                      Explore pages
                    </Link>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-6">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={require("../assets/img/theme/landing-3.png")}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1>{I18n.get("Built for success")}</h1>
                    <p>
                      Your sucess is our number one goal. See how asOne and its
                      products can be integrated into your workflow. We have
                      several use cases for you to explore by industry.
                    </p>
                    <Link
                      className="font-weight-bold text-info mt-5"
                      to="/admin/widgets"
                    >
                      See uses cases
                    </Link>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-7 section-nucleo-icons bg-white overflow-hidden">
            <Container>
              <Row className="justify-content-center">
                <Col className="text-center" lg="8">
                  <h2 className="display-3">
                    {I18n.get("Third Party Integrations")}
                  </h2>
                  <p className="lead">{I18n.get("thirdPartyText")}</p>
                  <div className="btn-wrapper">
                    <Button
                      color="info"
                      href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/icons?ref=adpr-index-page"
                      target="_blank"
                    >
                      {I18n.get("See Our Integrations")}
                    </Button>
                    <Button
                      className="mt-3 mt-md-0"
                      color="default"
                      href="https://nucleoapp.com/?ref=1712"
                      target="_blank"
                    >
                      {I18n.get("Work With Us")}
                    </Button>
                  </div>
                </Col>
              </Row>
              <div className="blur--hover">
                <a
                  href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/icons?ref=adpr-index-page"
                  target="_blank"
                >
                  <div className="icons-container blur-item mt-5">
                    <i className="icon">
                      <img src={require("../assets/img/asone.svg")} />
                    </i>

                    <i className="icon icon-sm fab fa-dropbox" />
                    <i className="icon icon-sm fab fa-google" />
                    <i className="icon icon-sm fab fa-apple" />

                    <i className="icon fab fa-mailchimp" />
                    <i className="icon fab fa-drupal" />
                    <i className="icon fab fa-wordpress" />

                    <i className="icon icon-sm ni ni-briefcase-24" />
                    <i className="icon icon-sm ni ni-building" />
                    <i className="icon icon-sm fab fa-trello" />

                    <i className="icon ni fab fa-instagram" />
                    <i className="icon ni fab fa-facebook" />
                    <i className="icon ni fab fa-twitter" />
                  </div>
                  <span className="blur-hidden h5 text-success">
                    See how we can help you with integrations
                  </span>
                </a>
              </div>
            </Container>
          </section>
          <section className="py-7">
            <Container>
              <Row className="row-grid justify-content-center">
                <Col className="text-center" lg="8">
                  <h2 className="display-3">
                    {I18n.get("A Fully Functional API")}
                    <span className="text-success">
                      {I18n.get("apiSubtitle")}
                    </span>
                  </h2>
                  <p className="lead">{I18n.get("apiSubtitle")}</p>
                  <div className="btn-wrapper">
                    <Button
                      className="btn-neutral mb-3 mb-sm-0"
                      color="default"
                      href="https://www.creative-tim.com/product/argon-dashboard-react?ref=adpr-index-page"
                      target="_blank"
                    >
                      {I18n.get("API Documentation")}
                    </Button>
                  </div>
                  <div className="icons-container blur-item mt-5">
                    <h4 className="display-4 mb-5 mt-5">
                      {I18n.get("Available in these languages")}
                    </h4>
                    <Row className="justify-content-center">
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro?ref=adpr-index-page"
                          id="tooltip170669606"
                          target="_blank"
                        >
                          <i className="icon fab fa-js fa-3x" />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip170669606"
                        >
                          Bootstrap 4 - Most popular front-end component library
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro-react?ref=adpr-index-page"
                          id="tooltip374813715"
                          target="_blank"
                        >
                          <i className="icon fab fa-node fa-3x" />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip374813715"
                        >
                          React - A JavaScript library for building user
                          interfaces
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro-nodejs?ref=adpr-index-page"
                          id="tooltip374813715"
                          target="_blank"
                        >
                          <i className="icon fab fa-swift fa-3x" />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip374813715"
                        >
                          React - A JavaScript library for building user
                          interfaces
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro-nodejs?ref=adpr-index-page"
                          id="tooltip374813715"
                          target="_blank"
                        >
                          <i className="icon fab fa-java fa-3x" />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip374813715"
                        >
                          React - A JavaScript library for building user
                          interfaces
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro-laravel?ref=adpr-index-page"
                          id="tooltip374813715"
                          target="_blank"
                        >
                          <i className="icon fa fa-terminal fa-3x" />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip374813715"
                        >
                          React - A JavaScript library for building user
                          interfaces
                        </UncontrolledTooltip>
                      </Col>
                    </Row>
                  </div>
                  <br />
                  <a href="">
                    {" "}
                    <p>{I18n.get("and more")}</p>
                  </a>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-7 section-nucleo-icons bg-white overflow-hidden">
            <Container>
              <Row className="justify-content-center">
                <Col className="text-center" lg="8">
                  <h2 className="display-3">
                    {I18n.get("Let's Get Connected")}
                  </h2>
                  <p className="lead">{I18n.get("Sign up for our emails")} </p>
                  <div className="btn-wrapper">
                    <Form>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Input
                              id="exampleFormControlInput1"
                              placeholder="name@example.com"
                              type="email"
                            />
                          </FormGroup>
                        </Col>
                        <Col xs={2}>
                          <Button
                            color="primary"
                            type="button"
                            onClick={this.validateCustomStylesForm}
                          >
                            {I18n.get("Sumbit")}
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
        <AuthFooter />
      </>
    );
  }
}

export default Index;
